import { NumberInput, SelectInput, SimpleForm, TextInput, required, useGetIdentity, useTranslate } from 'react-admin'
import taxes from '../taxes/taxes'
import { AddProductCommand } from '../GeneratedClients/FreeBillApi'
import Form from '../inputFormComponents/Form'
import FormCard from '../inputFormComponents/FormCard'
import FormRow from '../inputFormComponents/FormRow'

interface IProps {
  handleSubmit?: (fieldValues: AddProductCommand) => void
  productName?: string
}

const FormInput = ({handleSubmit, productName}: IProps) => {

  const translate = useTranslate()
  const { data: identity, isLoading: identityLoading } = useGetIdentity()
  if(identityLoading || !identity) return null

  const cards = [
    <FormCard title={translate('resources.products.name', {smart_count: 1})} rows={[
      <FormRow fields={[
        <TextInput fullWidth helperText={false} source='productName' validate={required()} label="resources.products.productName" />,
      ]} />,
      <FormRow fields={[
        <TextInput fullWidth multiline helperText={false} source='description' label="resources.products.description" />,
      ]} />,
      <FormRow fields={[
        <NumberInput fullWidth helperText={false} source='price' label="resources.common.price" />,
        <SelectInput sx={{ml:2}} fullWidth helperText={false} source='tax_in_percent' label="resources.common.tax_in_percent" choices={taxes} validate={required()} defaultValue={0.19} />
      ]} />,

    ]} />
  ]

  return (
    <SimpleForm defaultValues={{userId: identity.id, productName: productName}} onSubmit={handleSubmit} >
      <Form cards={cards} />
    </SimpleForm>
  )
}

export default FormInput